// import { request } from '@/myops/core'
import request from '@/lib/utils/request'
import { getChatSessionIdFromLocalStore } from '../util/ChatBotUtil'

export function chatV2(params) {
  return request({
    url: '/cssa/api/chat/chatV2',
    method: 'post',
    data: params,
    headers: { 'chat-session-id': getChatSessionIdFromLocalStore() },
  })
}

export function myopsChat(params) {
  return request({
    url: '/cssa/api/chat/myops-chat',
    method: 'post',
    data: params,
  })
}

export function getPlacesBuildingPageByCity(params) {
  return request({
    url: '/cssa/api/chat/getPlacesBuildingPageByCity',
    method: 'post',
    data: params,
  })
}

export function openNewChat() {
  return request({
    url: '/cssa/api/chat/resetChat',
    method: 'post',
  })
}

export function getChatBotQueryMessageHistoryList(params) {
  return request({
    url: '/cssa/api/chat/getChatBotQueryMessageHistoryList',
    method: 'get',
    params,
  })
}

export function addLike(data) {
  return request({
    url: '/cssa/api/chat/addLike',
    method: 'post',
    data,
  })
}

export function refreshAnswer(data) {
  return request({
    url: '/cssa/api/chat/refreshAnswer',
    method: 'post',
    data,
  })
}

export function createNewSession(data) {
  return request({
    url: '/cssa/api/chat/createNewSession',
    method: 'post',
    data,
  })
}

export function getChatBotAnswerMessageById(params) {
  return request({
    url: '/cssa/api/chat/getChatBotAnswerMessageById',
    method: 'get',
    params,
  })
}

export function deleteByChatSessionId(data) {
  return request({
    url: '/cssa/api/chat/deleteByChatSessionId',
    method: 'post',
    data,
  })
}

export function regenerateAnswer(params) {
  return request({
    url: '/cssa/api/chat/regenerateAnswer',
    method: 'get',
    params,
  })
}

export function getChatSessionId() {
  return request({
    url: '/cssa/api/chat/getChatSessionId',
    method: 'get',
  })
}

export function getChatLogsBySessionId(params) {
  return request({
    url: '/cssa/api/chat/getChatLogsBySessionId',
    method: 'get',
    params,
  })
}

export function renameChatSession(data) {
  return request({
    url: '/cssa/api/chat/renameChatSession',
    method: 'post',
    data,
  })
}

export function createQuery(data) {
  return request({
    url: '/cssa/api/query/create',
    method: 'post',
    data,
  })
}

export function reservationPlaces(data) {
  return request({
    url: '/cssa/api/mychatbot/reservationPlaces',
    method: 'post',
    data,
  })
}

export function v1_reservationPlaces(data) {
  return request({
    url: '/cssa/api/mychatbot/v1/reservationPlaces',
    method: 'post',
    data,
  })
}

export function addReservationPlacesMessage(data) {
  return request({
    url: '/cssa/api/chat/addReservationPlacesMessage',
    method: 'post',
    data,
  })
}

export function addPromptMessage(data) {
  return request({
    url: '/cssa/api/chat/addPromptMessage',
    method: 'post',
    data,
  })
}

export function lgiChat(params) {
  return request({
    url: '/cssa/api/chat/lgi-chat',
    method: 'post',
    data: params,
  })
}

export function chatMessage(data) {
  return request({
    url: '/cssa/api/chat/v2/chat-message',
    method: 'post',
    data,
  })
}

export function getLookUpByClassifyCode(params) {
  return request({
    url: '/cssa/api/lookup/getLookUpByClassifyCode',
    method: 'get',
    params,
  })
}

export function getBookedMeetingRoomsByEid(data) {
  return request({
    url: '/cssa/api/chat/getBookedMeetingRoomsByEid',
    method: 'post',
    data,
  })
}

export function cancelPlacesReservableInfo(data) {
  return request({
    url: '/cssa/api/mychatbot/cancelPlacesReservableInfo',
    method: 'post',
    data,
  })
}

export function saveComponentSelectionValue(data) {
  return request({
    url: '/cssa/api/answer/saveComponentSelectionValue',
    method: 'post',
    data,
  })
}

export function submitSatisfactionFeedback(params) {
  return request({
    url: '/cssa/api/answer/submitSatisfactionFeedback',
    method: 'get',
    params,
  })
}

export function getWorkOrderDesc(data) {
  return request({
    url: '/cssa/api/itWorkOrder/getDesc',
    method: 'post',
    data,
  })
}

export function saveFeedback(data) {
  return request({
    url: '/cssa/api/cssaFeedback/save',
    method: 'post',
    data,
  })
}

export function adminFeedback(data) {
  return request({
    url: '/cssa/api/cssaFeedback/adminFeedback',
    method: 'post',
    data,
  })
}

export function getFeedbackPageList(params) {
  return request({
    url: '/cssa/api/cssaFeedback/getPageList',
    method: 'get',
    params,
  })
}

// file
export function checkFile(params) {
  return request({
    url: '/cssa/api/file/check',
    method: 'get',
    params,
  })
}

export function uploadChunk(data) {
  return request({
    url: '/cssa/api/file/upload',
    method: 'post',
    data,
  })
}

export function mergeChunks(data) {
  return request({
    url: '/cssa/api/file/merge',
    method: 'post',
    data,
  })
}

export function getUploadProgress(params) {
  return request({
    url: '/cssa/api/file/progress',
    method: 'get',
    params,
  })
}

export function createItTicket(data) {
  return request({
    url: '/cssa/api/itWorkOrder/create',
    method: 'post',
    data,
  })
}

export function customMessage(data) {
  return request({
    url: '/cssa/api/query/customMessage',
    method: 'post',
    data,
  })
}

export function getLookUpByClassifyCodeV2(data) {
  return request({
    url: '/cssa/api/lookup/getLookUpByClassifyCodeV2',
    method: 'get',
    params: data,
  })
}



